import { BaseCheckpointModel } from '../BaseCheckpointModel';
export class EducationCheckpoint extends BaseCheckpointModel {
    constructor(checkpoint) {
        super(checkpoint);
        this.defaultObject = {
            institute: {
                name: '',
                accredited: false,
                accreditationInstitute: ''
            }
        };
        Object.assign(this, checkpoint);
        this.educations.map((educations, index) => {
            educations.id = `${index}_${new Date().getTime()}`;
            if (!educations.institute) {
                educations.institute = this.defaultObject.institute;
            }
        });
    }
}
export default EducationCheckpoint;
